import { EventIconAndTime } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/EventIconAndTime";
import { MatchPlayerNameAndScore  } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/MatchPlayerNameAndScore";
import type { IMatchGoalPenaltiesProps } from "@ihs-widget/components/StatsConsole/Widgets/OverviewWidget/parts/interfaces";


const MatchEventPenaltiesHome = ({ home_score, away_score, goalscorer, event_type }: IMatchGoalPenaltiesProps) => {
    return (
        <div className='flex justify-start mx-[16px] mb-[8px] min-h-[34px] max-h-[34px]'>
            <EventIconAndTime iconName={event_type} time={null} />
            <MatchPlayerNameAndScore 
                ml="8px" 
                mr="0px" 
                startPosition='start'
                event_type={event_type}
                player={goalscorer}
                homeScore={home_score}
                awayScore={away_score}
                isHomeGoal={true}

            />
        </div>
    )
}

export default MatchEventPenaltiesHome;

